<template>
  <v-btn
    class="revert-btn text-button-3 pa-0"
    variant="plain"
    color="brandPrimary"
    :disabled="disabled"
    @click="$emit('revert')"
  >
    Revert to Default
  </v-btn>
</template>

<script setup>
defineProps({
  disabled: { type: Boolean, default: false },
});

defineEmits(['revert']);
</script>

<style scoped lang="less">
.revert-btn {
  opacity: 1;
}
</style>
